// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as MergeIntoMap from "../mergeIntoMap/mergeIntoMap.jsx";
import * as Subsonic__GetAlbumInfo2 from "../api/subsonic/getAlbumInfo2.jsx";

function make(albumId) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    return Fx.Monad_syntax.let$star(Fx.provide(Subsonic__GetAlbumInfo2.make(albumId), {
      credentials: state.auth.credentials
    }), (function (albumInfo) {
      const state = store.getState();
      const infoById = MergeIntoMap.mergeIntoMap(state.albums.infoById, [albumInfo], (function (param) {
        return albumId;
      }));
      const state$1 = store.getState();
      if (infoById !== state$1.albums.infoById) {
        store.setState(function (prevState) {
          const init = prevState.albums;
          return {
            albums: {
              baseById: init.baseById,
              detailsById: init.detailsById,
              infoById: infoById,
              songIdsById: init.songIdsById
            },
            artists: prevState.artists,
            auth: prevState.auth,
            player: prevState.player,
            songs: prevState.songs
          };
        });
      }
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }));
  }));
}

export {
  make,
}
/* MergeIntoMap Not a pure module */
